export default __webpack_public_path__ + "static/media/Loanbuddy.268ac38c.png";